// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__36Aic","modalFooterButton":"ModalNotes_modalFooterButton__1rCcs"};